export const projectSpace = {
    addScheme: '添加方案',
    fileDeleted: '您访问的文件已被删除',
};
